import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { NgxPermissionsService } from 'ngx-permissions';
import { CommunityClubExistenceGQL } from '@graphql/generated/graphql';
import { map, of } from 'rxjs';

const BUSINESS_OWNER_ROLE = 'company-business-owner-role';

/**
 * Business owners always have access to push notifications. Employees (anyone without the
 * business owner role) may only send push notifications restricted to a community club, so they
 * only get access if the company actually has community clubs.
 */
export const pushNotificationAccessGuard: CanActivateFn = () => {
  const router = inject(Router);
  const permissionsService = inject(NgxPermissionsService);
  const communityClubExistenceGQL = inject(CommunityClubExistenceGQL);

  const isBusinessOwner =
    BUSINESS_OWNER_ROLE in permissionsService.getPermissions();

  if (isBusinessOwner) {
    return of(true);
  }

  return communityClubExistenceGQL.fetch().pipe(
    map(result => {
      const hasCommunityClubs = (result.data.communityClubs?.length ?? 0) > 0;
      return hasCommunityClubs
        ? true
        : router.createUrlTree(['/training-sessions']);
    })
  );
};
